import { Component, input, model, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ToggleComponent } from '@agilox/ui';

@Component({
	selector: 'cookie-option',
	templateUrl: './cookie-option.component.html',
	imports: [ToggleComponent, TranslatePipe],
})
export class CookieOptionComponent {
	title = input<string>('');
	cookieDescription = input<string>('');
	disabled = input<boolean>(false);
	isOn = model<boolean>(false);

	isOnChanged = output<boolean>();

	onChange(ev: boolean) {
		this.isOnChanged.emit(ev);
		this.isOn.update(() => ev);
	}
}
